/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExerciseDTO
 */
export interface ExerciseDTO {
    /**
     * 
     * @type {Date}
     * @memberof ExerciseDTO
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof ExerciseDTO
     */
    timeSpent: number;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    contentfulProgramId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    contentfulSubjectId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    contentfulWeekId: string | null;
    /**
     * 
     * @type {string}
     * @memberof ExerciseDTO
     */
    contentfulSessionId: string | null;
}

/**
 * Check if a given object implements the ExerciseDTO interface.
 */
export function instanceOfExerciseDTO(value: object): value is ExerciseDTO {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('timeSpent' in value) || value['timeSpent'] === undefined) return false;
    if (!('contentfulProgramId' in value) || value['contentfulProgramId'] === undefined) return false;
    if (!('contentfulSubjectId' in value) || value['contentfulSubjectId'] === undefined) return false;
    if (!('contentfulWeekId' in value) || value['contentfulWeekId'] === undefined) return false;
    if (!('contentfulSessionId' in value) || value['contentfulSessionId'] === undefined) return false;
    return true;
}

export function ExerciseDTOFromJSON(json: any): ExerciseDTO {
    return ExerciseDTOFromJSONTyped(json, false);
}

export function ExerciseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'timeSpent': json['timeSpent'],
        'contentfulProgramId': json['contentfulProgramId'],
        'contentfulSubjectId': json['contentfulSubjectId'],
        'contentfulWeekId': json['contentfulWeekId'],
        'contentfulSessionId': json['contentfulSessionId'],
    };
}

export function ExerciseDTOToJSON(json: any): ExerciseDTO {
    return ExerciseDTOToJSONTyped(json, false);
}

export function ExerciseDTOToJSONTyped(value?: ExerciseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString().substring(0,10),
        'timeSpent': value['timeSpent'],
        'contentfulProgramId': value['contentfulProgramId'],
        'contentfulSubjectId': value['contentfulSubjectId'],
        'contentfulWeekId': value['contentfulWeekId'],
        'contentfulSessionId': value['contentfulSessionId'],
    };
}

